const translations = {
  "en": {
    "Download": "Download",
    "Download the Ed Wealth mobile app to get insights instantly.": "Download the Ed: Wealth mobile app to get insights instantly."
  },
  "zh-tw": {
    "Download": "下載",
    "Download the Ed Wealth mobile app to get insights instantly.": "下載 Ed: Wealth APP 即時獲取資訊。"
  }
};

export default translations;
